export function resolvePromoCafeName(
  promo: { cafe_id?: string | number; cafe_name?: string | null },
  cafes: Array<{ id: string | number; name: string }>
): string {
  const named = String(promo.cafe_name || '').trim();
  if (named && named.toLowerCase() !== 'undefined' && named.toLowerCase() !== 'null') {
    return named;
  }
  const cafeId = String(promo.cafe_id || '').trim();
  if (!cafeId) return '';
  return cafes.find((cafe) => String(cafe.id) === cafeId)?.name?.trim() || '';
}
